export default __webpack_public_path__ + "static/media/sms.33a8dbbf.svg";